const moment = require('moment');
export default {
    appendParam(name, param, url, baseUrl){
        if(!this.isBlank(param)){
            if(url == baseUrl){
                url+="?"+name+"="+param;
            } else {
                url+="&"+name+"="+param;
            }
        }
        return url;
    },
    isEmpty(val){
        if(val == undefined || val == "") return true;
        return false;
    },
    isBlank: function (str) {
        if(typeof str === 'boolean' || this.isInt(str)){
            return false;
        } else {
            return (!str || /^\s*$/.test(str))
        }
    },
    isInt: function(value) {
        var x;
        if (isNaN(value)) {
            return false;
        }
        x = parseFloat(value);
        return (x | 0) === x;
    },
    dataURLtoFile(dataurl, filename) {
        var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while(n--){
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, {type:mime});
    },
    timeout(title, message){
        return (title.length * 60 + message.length * 60);
    },
    success(title, message){
        window.app.popupmessages.push({timer: this.timeout(title, message), type: 'success', header: title, description: message});
    },
    warning(title, message){
        window.app.popupmessages.push({timer: this.timeout(title, message), type: 'warning', header: title, description: message});
    },
    error(title, message){
        window.app.popupmessages.push({timer: this.timeout(title, message), type: 'error', header: title, description: message});
    },
    info(title, message){
        window.app.popupmessages.push({timer: this.timeout(title, message), type: 'info', header: title, description: message});
    },
    convertDateString(datestr){
        if(!this.isBlank(datestr)) {
            return moment.utc(datestr).format('YYYY-MM-DDTHH:mmZ');
        } else {
            return null;
        }
    },
    convertDateTimeString(datestr, timestr){

        if(!this.isBlank(datestr) && !this.isBlank(timestr)){
            return moment.utc(datestr+'T'+timestr).format('YYYY-MM-DDTHH:mmZ');
        } else if(!this.isBlank(datestr)) {
            return moment.utc(datestr+'T00:00:00').format('YYYY-MM-DDTHH:mmZ');
        } else if(!this.isBlank(timestr)){
            return moment.utc(timestr, 'HH:mm').format('HH:mmZ');
        } else {
            return null;
        }
    },
    convertLocalDateTimeString(datestr, timestr){

        if(!this.isBlank(datestr) && !this.isBlank(timestr)){
            return moment(datestr+'T'+timestr).format('YYYY-MM-DDTHH:mmZ');
        } else if(!this.isBlank(datestr)) {
            return moment(datestr+'T00:00:00').format('YYYY-MM-DDTHH:mmZ');
        } else if(!this.isBlank(timestr)){
            return moment(timestr, 'HH:mm').format('HH:mmZ');
        } else {
            return null;
        }
    },
    extractDateString(datestr, format="YYYY-MM-DD"){
       if(!this.isBlank(datestr)) {
            return moment.utc(datestr).format(format);
        } else {
            return null;
        }
            
    },
    extractTimeString(str, format="HH:mm"){
        if(!this.isBlank(str)){
            return moment.utc(str, 'HH:mmZ').format(format);
        } else {
            return null;
        }
        
    },
    getMoment() {
        return moment;
    },
    getMomentUTC() {
        return moment.utc();
    },
    getMomentFromString(str, format='YYYY-MM-DDTHH:mmZ'){
        return moment(str, format);
    },
    getCurrentMonthMoment(){
        return moment().date(1).hours(0).minutes(0).seconds(0).milliseconds(0);
    },
    getMomentFromValues(year, month, day, hours = 0, minutes = 0, seconds = 0, milliseconds = 0) {
        return moment().year(year).month(month).date(day).hours(hours).minutes(minutes).seconds(seconds).milliseconds(milliseconds);
    },
    getMomentFromStringUTC(str, format='YYYY-MM-DDTHH:mmZ'){
        return moment.utc(str, format);
    },
    getCurrentMonthMomentUTC(){
        return moment.utc().date(1).hours(0).minutes(0).seconds(0).milliseconds(0);
    },
    getMomentFromValuesUTC(year, month, day, hours = 0, minutes = 0, seconds = 0, milliseconds = 0) {
        return moment.utc().year(year).month(month).date(day).hours(hours).minutes(minutes).seconds(seconds).milliseconds(milliseconds);
    },
    gender(code) {
        switch(code) {
            case 'M':
                return "männlich";
            case 'F':
                return "weiblich";
            default:
                return "";
        }
    },
    salutation(code) {
        switch(code) {
            case 'M':
                return "Herr";
            case 'F':
                return "Frau";
            default:
                return "";
        }
    },
}